export default __webpack_public_path__ + "static/media/tactor-fig-1.dd974484.svg";